import {
    Component,
    OnInit,
    ChangeDetectorRef,
    AfterContentChecked,
} from '@angular/core';
import {
    UntypedFormGroup,
    Validators,
    UntypedFormBuilder,
    UntypedFormControl,
} from '@angular/forms';
import { EmployeeService } from '../../../employee/services/employee.service';
import { MatDialogRef } from '@angular/material/dialog';
import {
    NineCharacterValidation,
    PostalCodeValidation,
    noWhiteSpacesValidator,
    AdultValidation,
} from 'app/modules/common/validation/common-validation';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import {
    filter,
    tap,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    map,
} from 'rxjs/operators';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DireccionService } from 'app/modules/employee-view/services/direccion.service';
import { EmployeeCreateModel } from '../../entities/create-new-employee';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import moment from 'moment';
import { CustomFormControl } from 'app/modules/employee-view/entities/customFormControl';
import { EmpresaTreeViewService } from '../../services/empresa-treeView.service';
import { EmpresaService } from 'app/modules/employee-view/services/empresa.service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { RoutingServiceService } from 'app/modules/common/services/routing-service.service';
import { RestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { Trabajador } from 'app/modules/common/types/employee/trabajador.type';
import { Router } from '@angular/router';
import { LeaveOperations } from 'app/modules/common/enums/leave-operations';
import { EMPLOYEE_VIEW_KEY } from 'app/modules/employee-view/employee-view.component';
import { ApiCallsHelper } from 'app/modules/common/helpers/ApiCallsHelper';
import { EmloyeeAvailableCheckProps } from 'app/modules/common/types/employee/emloyee-available-check-props.type';
import { CommonDialogService } from 'app/modules/common/services/common-dialog.service';
import { Empresa } from 'app/modules/common/types/empresa.type';

@Component({
    selector: 'app-create-new-employee',
    templateUrl: './create-new-employee.component.html',
    styleUrls: ['./create-new-employee.component.scss'],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
    standalone: false
})
export class CreateNewEmployeeComponent implements OnInit, AfterContentChecked {
    createNewEmployeeFormGroup: UntypedFormGroup;
    headerName: string;
    public provinceList: Array<{ value: string; viewValue: string }>;
    direction1Validating: boolean;
    direction1Validated: boolean;
    direction2Validating: boolean;
    direction2Validated: boolean;
    NIFValidating: boolean;
    isHireDateVisible: boolean = true;
    isContractEndDateVisible: boolean = true;
    isEmployeeRefVisible: boolean = true;
    puestoControl: CustomFormControl = new CustomFormControl();
    isCompanyEligible: boolean = false;
    showCompanyIneligibleMsg: boolean = false;
    isValidCompany: boolean = false;
    empresaDetails: any;
    selectedCompanyId: number = 0;
    isJordanAllowed = false;
    isOpen:number;
    

    constructor(
        public dialogRef: MatDialogRef<CreateNewEmployeeComponent>,
        private changeDetectionRef: ChangeDetectorRef,
        public employeeService: EmployeeService,
        public fb: UntypedFormBuilder,
        public directionService: DireccionService,
        private sharedService: SharedService,
        public companyTreeService: CompanyTreeViewService,
        private empresaTreeViewService: EmpresaTreeViewService,
        private empresaService: EmpresaService,
        private pageLoaderService: PageLoaderService,
        private routingService: RoutingServiceService,
        private router: Router,
        private commonDialogsService: CommonDialogService
    ) {
        this.headerName = 'Crear un nuevo empleado';
        this.selectedCompanyId = Number(localStorage.getItem('Empresa'));
    }

    ngOnInit(): void {
        this.isOpen=0;
        this.getHardCodedList();
        this.initCreateNewEmployeeForm();
        this.getAllProvinces();
        this.postalCodeEventListener();
    }

    ngAfterContentChecked(): void {
        this.changeDetectionRef.detectChanges();
    }

    //#region "Form initiaziation"

    initCreateNewEmployeeForm(): void {
        this.createNewEmployeeFormGroup = this.fb.group({
            Name: [
                '',
                [
                    Validators.required,
                    this.noLeadingWhitespaceValidator,
                    Validators.maxLength(30),
                ],
            ],
            Surname: ['', [Validators.required, Validators.maxLength(40)]],
            NIF: [null, [noWhiteSpacesValidator(), Validators.maxLength(10)]],
            EmployeeRef: [''],
            BirthDate: [null, AdultValidation()],
            Gender: ['', [Validators.required]],
            
            Telephone1: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Telephone2: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Movil: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Telephone4: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Direction1: [''],
            Province1: [''],
            City1: [''],
            PostalCode1: [
                '',
                [PostalCodeValidation(), Validators.pattern('[0-9]*')],
            ],
            Direction2: [''],
            Province2: [''],
            City2: [''],
            PostalCode2: [
                '',
                [PostalCodeValidation(), Validators.pattern('[0-9]*')],
            ],
            Observation: [''],
            HiringDate: ['', [Validators.required]],
            ContractEndDate: [''],
            SS: ['', [Validators.maxLength(21), Validators.pattern('[0-9]*')]],
            Age: [''],
            WorkingHourPercent: [''],
            Urgent: [''],
            Attributes: this.fb.group({
                Attribute1: [''],
                Attribute2: [''],
                Attribute3: [''],
                Attribute4: [''],
                Attribute5: [''],
                Attribute6: [''],
                Attribute7: [''],
                Attribute8: [''],
                Attribute9: [''],
                Attribute10: [''],
                Attribute11: [''],
                Attribute12: [''],
            }),
            Position: [''],
        });
        this.triggerCompanyChange();
    }

    public noLeadingWhitespaceValidator(control: UntypedFormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    }

    //#endregion

    //#region "dropdown data generation"
    getHardCodedList(): void {
        this.provinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];
    }

    getProvinceCities(province: string): void {
        this.directionService.getProvinceCities(province).subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }

    getProvince2Cities(province: string): void {
        this.directionService.getProvince2Cities(province).subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }

    getAllProvinces() {
        this.directionService.getAllProvince().subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }
    //#endregion

    //#region "on text change validations"

    postalCodeEventListener(): void {
        this.createNewEmployeeFormGroup
            .get('PostalCode1')
            .valueChanges.pipe(
                filter((x) => {
                    return x !== null && x.length === 5;
                }),
                tap((_) => {
                    this.direction1Validating = true;
                    this.direction1Validated = false;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((postalCode: string) => {
                    return this.directionService
                        .validateAddressByCp(postalCode)
                        .pipe(
                            map((resp) => {
                                return resp.result;
                            })
                        );
                })
            )
            .subscribe(
                (res) => {
                    if (res === null) {
                        this.direction1Validating = false;
                    } else {
                        this.createNewEmployeeFormGroup
                            .get('Province1')
                            .patchValue(res.province);
                        this.createNewEmployeeFormGroup
                            .get('City1')
                            .patchValue(res.city);
                        this.direction1Validated = true;
                        this.direction1Validating = false;
                    }
                },
                (err) => {
                    console.error(err);
                }
            );

        this.createNewEmployeeFormGroup
            .get('PostalCode2')
            .valueChanges.pipe(
                filter((x) => {
                    return x !== null && x.length === 5;
                }),
                tap((_) => {
                    this.direction2Validating = true;
                    this.direction2Validated = false;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((postalCode: string) => {
                    return this.directionService
                        .validateAddressByCp(postalCode)
                        .pipe(
                            map((resp) => {
                                return resp.result;
                            })
                        );
                })
            )
            .subscribe(
                (res) => {
                    if (res === null) {
                        this.direction2Validating = false;
                    } else {
                        this.createNewEmployeeFormGroup
                            .get('Province2')
                            .patchValue(res.province);
                        this.createNewEmployeeFormGroup
                            .get('City2')
                            .patchValue(res.city);
                        this.direction2Validated = true;
                        this.direction2Validating = false;
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    //#endregion

    //#region "company selector change events"
    triggerCompanyChange(): void {
        this.getCompanyDetailsAndSetControls(this.selectedCompanyId, true);
        this.createNewEmployeeFormGroup.markAllAsTouched();
    }

    async onChangeCompany(event: any): Promise<void> {
       
        this.getCompanyDetailsAndSetControls(event.id, false);
    }
    async CheckEmployee()
    {
        if(this.isOpen==0)
        {
            const availableEmp = await this.checkIfCompanyIsAvailable();

            // if emp is available ask user about creating a new one
            if (
                !availableEmp ||
                (await this.getUserConfirmationToCreateEmp(availableEmp))
            ) {
    
               //this.createNewEmployee();
            } else {
                this.routingService.selectEmployee(availableEmp);
                this.dialogRef.close();
            }
        }
    }

    getCompanyDetailsAndSetControls(
        companyId: number,
        isOnLoad: boolean
    ): void {
        if (!isOnLoad) {
            this.pageLoaderService.ShowPageLoader();
        }

        this.empresaTreeViewService.getEmpresa(companyId).subscribe(
            async (res) => {
                if (!isOnLoad) {
                    this.pageLoaderService.HidePageLoader();
                }

                if (res && res != null) {                
                    let result = res.result;
                    this.empresaDetails = result;
                    this.selectedCompanyId = result.empresaId;
                    this.isValidCompany = true;

                    // check if jordan value should be displayed
                    this.setIsJordanAllowed();

                    //#region "Same logic used in 'ConfigureBasicEmployee()' method in 'app\modules\employee-view\create-actuaciones\employee-edit' component"
                    if (
                        result.refTrabajador === null ||
                        result.refTrabajador !== 'S'
                    ) {
                        this.createNewEmployeeFormGroup.removeControl(
                            'EmployeeRef'
                        );
                        this.isEmployeeRefVisible = false;
                    }
                    //fantiguedad= Company hiring date
                    if (
                        result.fantiguedad === null ||
                        (result.fantiguedad !== 'S' &&
                            result.fantiguedad !== 'O')
                    ) {
                        this.createNewEmployeeFormGroup.removeControl(
                            'HiringDate'
                        );
                        this.isHireDateVisible = false;
                    }
                    if (
                        result.fantiguedad !== null &&
                        result.fantiguedad === 'O'
                    ) {
                        this.createNewEmployeeFormGroup
                            .get('HiringDate')
                            .setValidators(Validators.required);
                    }
                    //ffinContrato= Company contract end date
                    if (
                        result.ffinContrato !== null &&
                        result.ffinContrato !== 'S'
                    ) {
                        this.createNewEmployeeFormGroup.removeControl(
                            'ContractEndDate'
                        );
                        this.isContractEndDateVisible = false;
                    }

                    this.createNewEmployeeFormGroup.get('Age').disable();

                    // Puesto
                    //this.configurePuestoControl(result);

                    //#endregion

                    //#region "New logic=> Check company eligibility"
                    if (result.tieneTrabajadores != 'S') {
                        this.isCompanyEligible = false;
                        this.showCompanyIneligibleMsg = true;
                    } else {
                        this.isCompanyEligible = true;
                        this.showCompanyIneligibleMsg = false;
                    }
                    //#endregion

                    if(this.isOpen==0)
                    {
                        const availableEmp = await this.checkIfCompanyIsAvailable();
                        // if emp is available ask user about creating a new one
                        if (
                            !availableEmp ||
                            (await this.getUserConfirmationToCreateEmp(availableEmp))
                        ) {
                
                           //this.createNewEmployee();
                        } else {
                            this.routingService.selectEmployee(availableEmp);
                            this.dialogRef.close();
                        }
                    }
                    
                }
            },
            (error) => {
                if (!isOnLoad) {
                    this.pageLoaderService.HidePageLoader();
                }

                console.error(error);
            }
        );
    }

    private async configurePuestoControl(company: Empresa) {
        // This value is just a decoy. only care about the last digit.(ie 0)
        this.puestoControl.Name = 'Attribute0';
        this.puestoControl.label = 'Puesto';

        // Puesto is always a drop down
        this.puestoControl.Dropdown = true;
        // add Puesto drop down options
        await this.populatePuestoDropDown(this.puestoControl);

        // if puesto has no options, do not display it
        if (!Boolean(this.puestoControl.Options?.length)) {
            this.createNewEmployeeFormGroup.removeControl('Position');
            return;
        }

        //obligatorio0 = mandotory0
        if (company.obligatorio0 === 'S') {
            this.puestoControl.Mandotory = true;
            this.createNewEmployeeFormGroup
                .get('Position')
                .setValidators(Validators.required);
        } else {
            this.puestoControl.Mandotory = false;
            this.createNewEmployeeFormGroup.get('Position').setValidators(null);
        }
        this.createNewEmployeeFormGroup
            .get('Position')
            .updateValueAndValidity();

        // check if custom inputs are allowed
        this.puestoControl.CustomInput = company.coincidir0 !== 'S';
    }

    populatePuestoDropDown(control: CustomFormControl): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (control.Dropdown) {
                const index: number = Number(control.Name.substr(9));
                this.empresaService
                    .GetAttributesByIndex(this.selectedCompanyId, index)
                    .pipe(
                        map((res) => {
                            return res.result.map((elem) => {
                                return { text: elem.texto, value: elem.texto };
                            });
                        })
                    )
                    .subscribe(
                        (result) => {
                            result.sort(function (a, b) {
                                return a.text.localeCompare(b.text);
                            });
                            control.Options = result;
                            resolve();
                        },
                        (err) => {
                            console.error(err);
                            reject();
                        }
                    );
            }
        });
    }

    /**
     * Check if Jordan value is allowed and change `isJordanAllowed` accordingly
     * This function will use `empresaDetails` variable to check data, make sure this value is initialized
     */
    private setIsJordanAllowed(): void {
        // first disable Jordan
        this.isJordanAllowed = false;

        // % Jornada field should visible,if all Empresa.MultiAtributoX are null or = ‘N’
        for (let attributeIndex = 1; attributeIndex < 13; attributeIndex++) {
            const multiAtributo = this.empresaDetails[
                `multiAtributo${attributeIndex}`
            ] as string;

            // If any of the multi attribute is neigther null nor N, exit function
            if (multiAtributo !== null && multiAtributo !== 'N') return;
        }

        // if function comes this far, Joradan value is allowed
        this.isJordanAllowed = true;
    }

    //#endregion

    //#region "Birthday and age"
    calculateAge(birthDate: moment.Moment): number {
        if (birthDate === null) {
            return 0;
        }
        const now = moment();
        const today = moment({
            y: now.year(),
            M: now.month(),
            d: now.date(),
            h: 0,
            m: 0,
            s: 0,
            ms: 0,
        });
        return today.diff(birthDate, 'years');
    }

    onchangeBirthDate(type: string, event) {
        const age = this.calculateAge(event.value);
        this.createNewEmployeeFormGroup.get('Age').patchValue(age);
    }
    //#endregion

    //#region "Add employee"

    async onSubmit() {
        this.createNewEmployee();
        // const availableEmp = await this.checkIfCompanyIsAvailable();

        // // if emp is available ask user about creating a new one
        // if (
        //     !availableEmp ||
        //     (await this.getUserConfirmationToCreateEmp(availableEmp))
        // ) {
        //     this.createNewEmployee();
        // } else {
        //     this.routingService.selectEmployee(availableEmp);
        //     this.dialogRef.close();
        // }
    }

    /**
     * Check if user wants to create employee
     */
    private async getUserConfirmationToCreateEmp(
        availableEmp: Trabajador
    ): Promise<boolean> {
        // if user is blocked, ask to unblock it
        if (availableEmp.bloqueado === 'S') {
            this.isOpen=1;
            const unblockEmp: boolean = await this.commonDialogsService
                .openConfirmationDialog(
                    'Existe un trabajador con este nombre, número de referencia o NIF en esta empresa, pero está bloqueado. ¿Quieres desbloquearlo?'
                )
                .afterClosed()
                .toPromise();
            if (unblockEmp) {
                await ApiCallsHelper.toPromise(
                    this.employeeService.unblockEmployee(
                        availableEmp.trabajadorId
                    )
                );
                return false;
            } else return true;
        } else {
            this.isOpen=1;
            return !(await this.commonDialogsService
                .openConfirmationDialog(
                    'Ya hay un trabajador con este nombre, número de referencia o NIF en esta empresa. ¿Ir al trabajador?'
                )
                .afterClosed()
                .toPromise());
        }
    }

    /**
     * Create emp
     */
    private createNewEmployee() {
        this.createNewEmployeeFormGroup.markAllAsTouched();
        this.createNewEmployeeFormGroup.updateValueAndValidity();

        if (
            this.createNewEmployeeFormGroup.valid &&
            this.selectedCompanyId > 0 &&
            this.isCompanyEligible
        ) {
            this.pageLoaderService.ShowPageLoader();

            const employeeFormValues = this.createNewEmployeeFormGroup.value;
            let empCreateModel = this.transformToSaveModel(employeeFormValues);
            this.employeeService.createNewEmployee(empCreateModel).subscribe(
                (res: RestResponse<Trabajador>) => {
                    this.pageLoaderService.HidePageLoader();
                    if (res) {
                        this.sharedService.ShowSnackBar(
                            'Empleado creado con éxito',
                            '',
                            2500
                        );
                        this.dialogRef.close();
                        this.createNewEmployeeFormGroup.reset();

                        // then move to create leave
                        this.routingService.addAfterRoutingTask(
                            EMPLOYEE_VIEW_KEY,
                            () =>
                                setTimeout(
                                    () =>
                                        this.router.navigate([
                                            '/create-leave',
                                            res.result.trabajadorId,
                                            LeaveOperations.NewLeave,
                                        ]),
                                    0
                                )
                        );

                        // move to employee view
                        this.routingService.selectEmployee(res.result);
                    } else {
                        this.sharedService.ShowSnackBar(
                            'Ocurrió un error',
                            'Okay',
                            2500
                        );
                    }
                },
                (error) => {
                    this.pageLoaderService.HidePageLoader();
                    this.sharedService.ShowSnackBar(
                        'Ocurrió un error',
                        'Okay',
                        2500
                    );
                    console.error(error);
                }
            );
        } else {
            this.sharedService.ShowSnackBar(
                'Inserte datos válidos para continuar'
            );
        }
    }

    /**
     * Check if emp is available for the current form values
     */
    private checkIfCompanyIsAvailable(): Promise<Trabajador> {
        
        //var EmployeeRef =this.createNewEmployeeFormGroup.get('EmployeeRef').value ==null ? '' : this.createNewEmployeeFormGroup.get('EmployeeRef').value;
        const checkProps: EmloyeeAvailableCheckProps = {
            empresaId: this.selectedCompanyId,
            nif: this.createNewEmployeeFormGroup.get('NIF').value,
            nombre: this.createNewEmployeeFormGroup.get('Name').value,
            apellidos: this.createNewEmployeeFormGroup.get('Surname').value,
            refTrabajador: this.createNewEmployeeFormGroup.get('EmployeeRef')?.value
        };

        return ApiCallsHelper.toPromise(
            this.employeeService.isEmployeeAvailable(checkProps)
        );
    }

    transformToSaveModel(formGroupObj: any): EmployeeCreateModel {
        let newEmployee = new EmployeeCreateModel();
        let attributesFormGroup = this.createNewEmployeeFormGroup.get(
            'Attributes'
        ) as UntypedFormGroup;
        let attributeValues = attributesFormGroup.controls;

        //Main details
        newEmployee.NIF = formGroupObj.NIF;
        newEmployee.Name = formGroupObj.Name;
        newEmployee.Surname = formGroupObj.Surname;
        newEmployee.Gender = formGroupObj.Gender;
        newEmployee.SS = formGroupObj.SS;
        newEmployee.CompanyId = this.selectedCompanyId;
        newEmployee.BirthDate = this.formatDateOnly(formGroupObj.BirthDate);
        newEmployee.Position = formGroupObj.Position;
        newEmployee.Telephone1 = formGroupObj.Telephone1;
        newEmployee.Telephone2 = formGroupObj.Telephone2;
        newEmployee.Movil = formGroupObj.Movil;
        newEmployee.Telephone4 = formGroupObj.Telephone4;
        newEmployee.Direction1 = formGroupObj.Direction1;
        newEmployee.Province1 = formGroupObj.Province1;
        newEmployee.City1 = formGroupObj.City1;
        newEmployee.PostalCode1 = formGroupObj.PostalCode1;
        newEmployee.Direction2 = formGroupObj.Direction2;
        newEmployee.Province2 = formGroupObj.Province2;
        newEmployee.City2 = formGroupObj.City2;
        newEmployee.PostalCode2 = formGroupObj.PostalCode2;
        newEmployee.Observation = formGroupObj.Observation;
        newEmployee.HiringDate = this.formatDateOnly(formGroupObj.HiringDate) ;
        newEmployee.ContractEndDate = formGroupObj.ContractEndDate;
        newEmployee.EmployeeRef =
            formGroupObj.EmployeeRef === '' ? null : formGroupObj.EmployeeRef;
        newEmployee.Urgent = formGroupObj.Urgent;
        newEmployee.Jornada = formGroupObj.WorkingHourPercent;

        // Fill up employee attributes
        for (let attributeIndex = 1; attributeIndex <= 13; attributeIndex++) {
            // get attribute name
            const attributeName = `Attribute${attributeIndex}`;

            // get attribute contrp;
            const attribute = attributeValues[attributeName];

            // set employee attribute
            newEmployee[attributeName] =
                !attribute || attribute.value == '' ? null : attribute.value;
        }

        return newEmployee;
    }

    formatDateOnly(date: Date | string | null): string | null {
        if (!date) return null;
    
        const d = new Date(date);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
    
        return `${year}-${month}-${day}`;
    }

    //#endregion

    //#region "Pop up functions"
    cancel() {
        this.dialogRef.close();
        this.createNewEmployeeFormGroup.reset();
    }
    //#endregion
}
